import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import CapacityDataProvider from 'scaleflow/controllers/planning/dashboard/capacity/capacity-data-provider';

export default class PlanningDashboardCapacityWeeksController extends CapacityDataProvider {
  @service intl;
  @service('roadmap') roadmapService;
  @tracked initiatives = [];
  @tracked roadmap;
  @tracked scenario;

  @tracked grouping = 'statuses';
  @tracked statuses = [];
  @tracked themes = [];
  @tracked sources = [];
  @tracked product_managers = [];
  @tracked teams = [];
  @tracked columns = [
    'Progress',
    'Owner',
    'Effort',
    'Uncertainty',
    'Starting week',
    'Duration',
  ];

  @action
  async loadInitiatives() {
    this.initiatives = await this.roadmapService.initiatives;
  }

  @action
  async loadScenario() {
    this.scenario = await this.roadmapService.scenario;
  }

  @action
  async loadRoadmap() {
    this.roadmap = await this.roadmapService.selected;
  }

  @action
  toggleInitiativeForm(val) {
    if (val !== undefined) this.initiativeFormIsVisible = val;
    else this.initiativeFormIsVisible = !this.initiativeFormIsVisible;
  }

  @action
  setRoadmapOnInitiative(initiative) {
    const roadmap = this.store.peekRecord('roadmap', this.roadmap_id);
    initiative.roadmaps = [roadmap];
    initiative.save();
  }
}
